import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** Shared presentation; filtering and exports remain owned by each module. */
@Component({
  selector: 'app-table-toolbar',
  standalone: false,
  templateUrl: './table-toolbar.component.html',
  styleUrls: ['./table-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableToolbarComponent {
  private static nextId = 0;
  readonly searchId = `table-search-${TableToolbarComponent.nextId++}`;
  @Input() title = '';
  @Input() description = '';
  @Input() icon = 'fas fa-table';
  @Input() searchable = true;
  @Input() placeholder = 'Buscar en la tabla…';
  @Input() searchValue = '';
  @Input() exportable = false;
  @Input() loading = false;
  @Input() refreshable = false;
  @Input() refreshing = false;
  @Output() searchValueChange = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();
  @Output() pdf = new EventEmitter<void>();
  @Output() csv = new EventEmitter<void>();
  @Output() excel = new EventEmitter<void>();

  search(value: string): void {
    this.searchValue = value;
    this.searchValueChange.emit(value);
  }

  clearSearch(): void {
    // The parent clears all its filters in one operation (including backend filters).
    this.searchValue = '';
    this.clear.emit();
  }
}
